// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 1: 창세기
// ============================================================================
// 레벨 1-13 (13개 레벨, 39개 질문)

export const chapter1Translations = {
  name: "창세기",
  description: "태초에... 지식은 영혼을 살립니다",
  
  spiritualWisdom: {
    principle: "지식은 영혼을 살립니다",
    scripture: "내 백성이 지식이 없으므로 망하는도다 (호세아 4:6)",
    application: "공부한 모든 구절, 발견한 모든 진리가 우리 영혼을 양육하고 믿음을 강화합니다"
  },
  
  levels: {
    1: {
      name: "창조",
      challenge: "태초에 하나님이 천지를 창조하시니라...",
      easy: {
        question: "하나님은 며칠 만에 세상을 창조하셨습니까?",
        options: ["5일", "6일", "7일", "8일"],
        hint: "한 주의 안식일을 생각해보세요",
        funFact: "💡 제7일에 하나님이 쉬셨습니다. 이것이 안식일, 주간 휴식일의 기원입니다!"
      },
      medium: {
        question: "하나님은 넷째 날에 무엇을 창조하셨습니까?",
        options: ["동물들", "사람", "해와 달과 별들", "식물들"],
        hint: "이 피조물들은 땅을 비추고 시간을 정합니다",
        funFact: "🌟 광명들은 계절과 종교적 절기를 정하기 위해 창조되었습니다!"
      },
      hard: {
        question: "사람이 '하나님의 형상'으로 지음 받았다는 것은 무엇을 의미합니까?",
        options: [
          "동일한 외모",
          "창조하고 사랑하는 능력",
          "자연적 불멸",
          "신적 능력"
        ],
        hint: "영적이고 지적인 특성에 관한 것입니다",
        funFact: "✨ 우리 안의 하나님의 형상에는 창의성, 도덕적 양심, 사랑할 수 있는 능력이 포함됩니다!"
      }
    },
    
    2: {
      name: "동산의 유혹",
      challenge: "뱀은 들짐승 중에 가장 간교하더라...",
      easy: {
        question: "동산에서 하와를 유혹한 동물은 무엇입니까?",
        options: ["사자", "뱀", "독수리", "용"],
        hint: "이 동물은 배로 기어다닙니다",
        funFact: "🐍 뱀은 성경 전체에서 유혹과 간교함을 상징합니다!"
      },
      medium: {
        question: "뱀은 하와에게 어떤 거짓 약속을 했습니까?",
        options: [
          "불멸할 것이다",
          "부유해질 것이다",
          "하나님처럼 될 것이다",
          "행복할 것이다"
        ],
        hint: "뱀은 신적 수준으로의 상승을 약속합니다",
        funFact: "🎭 뱀의 거짓말은 진실과 속임수를 섞습니다 - 고전적인 유혹 기술입니다!"
      },
      hard: {
        question: "이 타락은 선악의 투쟁을 어떻게 밝혀줍니까?",
        options: [
          "악이 더 강하다",
          "자유의지는 책임을 의미한다",
          "하나님이 우리를 버리신다",
          "유혹은 무적이다"
        ],
        hint: "선택하고 결과를 감수하는 능력에 관한 것입니다",
        funFact: "🌳 지식의 나무는 인류를 정의하는 도덕적 선택을 상징합니다!"
      }
    },
    
    3: {
      name: "가인과 아벨",
      challenge: "두 형제, 두 제물, 영원한 비극...",
      easy: {
        question: "성경 역사상 첫 번째 살인자는 누구입니까?",
        options: ["아벨", "셋", "가인", "아담"],
        hint: "아벨을 시기한 형제",
        funFact: "⚡ 가인은 파괴적인 형제 질투의 상징이 됩니다!"
      },
      medium: {
        question: "하나님이 아벨의 제물을 기뻐하신 이유는 무엇입니까?",
        options: [
          "양이 더 많았다",
          "아벨이 더 잘생겼다",
          "진실한 마음으로 드렸다",
          "고기였다"
        ],
        hint: "하나님은 마음을 보십니다",
        funFact: "❤️ 하나님은 마음을 보십니다, 우리 행동의 겉모습만이 아닙니다!"
      },
      hard: {
        question: "이 이야기는 질투에 대해 무엇을 가르칩니까?",
        options: [
          "질투는 자연스럽다",
          "통제되지 않은 질투는 파괴로 이어진다",
          "하나님은 일부를 편애하신다",
          "경쟁은 건강하다"
        ],
        hint: "감정을 통제하지 못한 결과에 관한 것입니다",
        funFact: "🔥 '죄가 문에 엎드려 있느니라' - 하나님은 타락 전에 경고하십니다!"
      }
    },

    4: {
      name: "노아의 홍수",
      challenge: "땅에 사십 주야를 비가 내렸더라...",
      easy: {
        question: "홍수의 비는 며칠 밤낮 동안 내렸습니까?",
        options: ["30일", "40일", "50일", "100일"],
        hint: "성경의 상징적 숫자",
        funFact: "☔ 40이라는 숫자는 성경에서 시련과 변화를 상징합니다!"
      },
      medium: {
        question: "노아는 방주에 정결한 짐승을 몇 쌍 태워야 했습니까?",
        options: [
          "1쌍",
          "2쌍",
          "7쌍",
          "10쌍"
        ],
        hint: "부정한 짐승보다 많이",
        funFact: "🦁 정결한 짐승들은 홍수 후 제사를 위한 것이었습니다!"
      },
      hard: {
        question: "방주는 우리의 영적 여정에서 무엇을 상징합니까?",
        options: [
          "문제로부터의 도피",
          "믿음과 순종을 통한 구원",
          "필요한 고립",
          "신자들의 우월성"
        ],
        hint: "믿는 자들에게 제공되는 구원에 관한 것입니다",
        funFact: "🚢 방주는 구원을 예표합니다: 심판에서 벗어나는 한 길!"
      }
    },

    5: {
      name: "바벨탑",
      challenge: "성과 탑을 건설하여 그 탑 꼭대기를 하늘에 닿게 하자...",
      easy: {
        question: "하나님은 바벨에서 무엇을 혼잡하게 하셨습니까?",
        options: ["계획", "언어", "도구", "생각"],
        hint: "소통을 가능하게 하는 것",
        funFact: "🗣️ 바벨은 세계 언어 다양성의 신화적 기원입니다!"
      },
      medium: {
        question: "사람들은 왜 이 탑을 건설하려 했습니까?",
        options: [
          "보호하기 위해",
          "함께 살기 위해",
          "이름을 내고 하늘에 닿기 위해",
          "하나님을 경배하기 위해"
        ],
        hint: "교만과 하나님과 같아지려는 욕망에 관한 것입니다",
        funFact: "🏗️ 하나님과 같아지려는 교만은 항상 혼란으로 이어집니다!"
      },
      hard: {
        question: "바벨의 교만은 오늘날 어떻게 나타납니까?",
        options: [
          "기술에서만",
          "하나님 없이 절대적 자율을 향한 인간의 의지에서",
          "고층 빌딩에서",
          "다른 언어에서"
        ],
        hint: "하나님 없이 지내려는 것에 관한 것입니다",
        funFact: "💭 바벨은 하나님 없는 연합이 파괴적인 교만이 됨을 상기시킵니다!"
      }
    },

    6: {
      name: "아브라함의 부르심",
      challenge: "네 고향과 친척과 아버지의 집을 떠나...",
      easy: {
        question: "아브라함이 고향을 떠날 때 몇 살이었습니까?",
        options: ["50세", "65세", "75세", "100세"],
        hint: "모든 것을 다시 시작하기에 매우 높은 나이",
        funFact: "🚶 75세에 아브라함은 새로운 삶을 시작합니다 - 너무 늦은 때는 없습니다!"
      },
      medium: {
        question: "하나님은 아브라함에게 어떤 세 가지 약속을 하셨습니까?",
        options: [
          "부, 권력, 지혜",
          "땅, 자손, 보편적 축복",
          "장수, 평화, 번영",
          "믿음, 소망, 사랑"
        ],
        hint: "전 인류와 관련된 약속",
        funFact: "🌟 아브라함에 대한 약속은 전 인류와 관련됩니다, 그만이 아닙니다!"
      },
      hard: {
        question: "아브라함의 '믿음의 도약'은 무엇을 가르칩니까?",
        options: [
          "맹목적 믿음은 위험하다",
          "하나님을 따르려면 우리의 안전을 놓아야 한다",
          "하나님은 특정 민족을 편애하신다",
          "믿음은 성공을 보장한다"
        ],
        hint: "기준점을 포기하고 신뢰하는 것에 관한 것입니다",
        funFact: "✨ 아브라함은 보지 않고 믿었기에 '믿음의 조상'이라 불립니다!"
      }
    },

    7: {
      name: "이삭의 제사",
      challenge: "네 아들 네 사랑하는 독자 이삭을 데리고...",
      easy: {
        question: "아브라함은 어느 산에서 이삭을 드려야 했습니까?",
        options: ["시내", "모리아", "갈멜", "시온"],
        hint: "이 산은 거룩한 장소가 될 것입니다",
        funFact: "🏔️ 모리아 산은 예루살렘 성전의 장소가 됩니다!"
      },
      medium: {
        question: "하나님은 이삭 대신 무엇을 준비하셨습니까?",
        options: [
          "어린 양",
          "뿔이 수풀에 걸린 숫양",
          "염소",
          "황소"
        ],
        hint: "뿔이 있는 성체 수컷",
        funFact: "🐏 대속의 숫양은 궁극적인 대속 제사를 예표합니다!"
      },
      hard: {
        question: "이 시험은 절대적 믿음을 어떻게 보여줍니까?",
        options: [
          "하나님은 잔인하게 시험하신다",
          "믿음은 부모의 사랑조차 초월한다",
          "인신 제사는 하나님을 기쁘게 한다",
          "아브라함은 이삭을 진정으로 사랑하지 않았다"
        ],
        hint: "이해하지 못해도 신뢰하는 것에 관한 것입니다",
        funFact: "💝 우리가 하나님을 신뢰할 때 하나님은 항상 출구를 마련하십니다!"
      }
    },

    8: {
      name: "야곱과 에서",
      challenge: "형이 아우를 섬길 것이다...",
      easy: {
        question: "에서는 무엇을 위해 장자권을 팔았습니까?",
        options: ["금", "렌즈콩 죽 한 그릇", "옷", "포도주"],
        hint: "배고픔을 채우기 위한 한 그릇",
        funFact: "🍲 순간의 배고픔이 에서에게 영원한 축복을 잃게 했습니다!"
      },
      medium: {
        question: "야곱은 어떻게 아버지 이삭을 속였습니까?",
        options: [
          "목소리를 바꿨다",
          "변장했다",
          "염소 가죽으로 몸을 덮었다",
          "이름에 대해 거짓말했다"
        ],
        hint: "털이 많은 형을 닮기 위해",
        funFact: "🎭 눈이 먼 이삭은 냄새와 촉감은 알아차렸지만 속임수는 알아차리지 못했습니다!"
      },
      hard: {
        question: "이 이야기는 우리의 선택에 대해 무엇을 드러냅니까?",
        options: [
          "속임수는 때때로 필요하다",
          "즉각적인 욕망이 우리의 운명을 희생시킬 수 있다",
          "하나님은 교활함을 인정하신다",
          "동생이 항상 선호된다"
        ],
        hint: "충동적인 결정의 결과에 관한 것입니다",
        funFact: "⚖️ 우리의 충동적인 선택은 영원한 결과를 초래할 수 있습니다!"
      }
    },

    9: {
      name: "야곱의 꿈",
      challenge: "땅 위에 세워진 사다리를 보았다. 그 꼭대기는 하늘에 닿았다...",
      easy: {
        question: "야곱은 꿈에서 무엇을 보았습니까?",
        options: [
          "거대한 나무",
          "천사들이 있는 하늘로 가는 사다리",
          "성전",
          "별들"
        ],
        hint: "하늘과 땅 사이의 소통 수단",
        funFact: "👼 야곱의 사다리는 하늘과 땅의 연결을 상징합니다!"
      },
      medium: {
        question: "야곱은 베개로 삼았던 돌을 어떻게 했습니까?",
        options: [
          "그것을 깼다",
          "그것을 묻었다",
          "그것을 세우고 기름을 부었다",
          "그것을 가져갔다"
        ],
        hint: "신성한 기념비로 만들었다",
        funFact: "🪨 이 돌은 '벧엘' - 하나님의 집이 됩니다!"
      },
      hard: {
        question: "이 환상은 우리의 삶에서 하늘과 땅을 어떻게 연결합니까?",
        options: [
          "꿈을 통해서만",
          "신과의 다리를 세우는 기도를 통해",
          "수호 천사를 통해",
          "성스러운 장소를 통해"
        ],
        hint: "하나님과의 우리의 소통에 관한 것입니다",
        funFact: "🌉 기도는 하늘로 가는 우리의 개인적인 사다리입니다!"
      }
    },

    10: {
      name: "형제들에게 팔린 요셉",
      challenge: "보라, 저 꿈꾸는 자가 온다...",
      easy: {
        question: "요셉에게는 몇 명의 형제가 있었습니까?",
        options: ["7명의 형제", "10명의 형제", "11명의 형제", "12명의 형제"],
        hint: "이스라엘 지파의 수보다 하나 적다",
        funFact: "👨‍👨‍👦‍👦 야곱의 12명의 아들은 이스라엘의 12 지파가 됩니다!"
      },
      medium: {
        question: "요셉은 몇 개의 은전에 팔렸습니까?",
        options: [
          "10개",
          "20개",
          "30개",
          "50개"
        ],
        hint: "노예의 가격",
        funFact: "💰 20개의 은전, 당시 노예의 가격이었습니다!"
      },
      hard: {
        question: "질투는 어떻게 하나님의 계획의 도구가 됩니까?",
        options: [
          "하나님은 질투를 인정하신다",
          "행해진 악은 하나님에 의해 선으로 변환된다",
          "질투는 필요하다",
          "형제들이 옳았다"
        ],
        hint: "악을 선으로 변환시키는 하나님의 섭리에 관한 것입니다",
        funFact: "🎨 하나님은 우리의 최악의 행동조차 은혜의 걸작으로 변환하십니다!"
      }
    },

    11: {
      name: "감옥의 요셉",
      challenge: "주께서 요셉과 함께 계셨고 그에게 자비를 베푸셨다...",
      easy: {
        question: "요셉은 어떤 특별한 은사를 가지고 있었습니까?",
        options: [
          "예언하다",
          "꿈을 해석하다",
          "병자를 치유하다",
          "동물과 대화하다"
        ],
        hint: "꿈과 관련된 능력",
        funFact: "💭 꿈은 고대 세계에서 신의 메시지로 여겨졌습니다!"
      },
      medium: {
        question: "요셉과 함께 감옥에 있었던 파라오의 신하는 누구였습니까?",
        options: [
          "재상과 서기",
          "술 맡은 관원과 떡 굽는 관원",
          "의사와 경비원",
          "요리사와 정원사"
        ],
        hint: "포도주를 내는 자와 빵을 내는 자",
        funFact: "🍷 술 맡은 관원은 독살을 방지하기 위해 왕의 포도주를 맛보았습니다!"
      },
      hard: {
        question: "요셉은 역경 속에서의 충실함에 대해 무엇을 가르쳐 줍니까?",
        options: [
          "불의는 받아들일 수 있다",
          "하나님에 대한 충실함은 환경을 초월한다",
          "감옥은 사람을 변화시킨다",
          "복수해야 한다"
        ],
        hint: "시련 중에도 충실하게 남아있는 것에 관한 것입니다",
        funFact: "⭐ 감옥에서도 요셉은 온전하게 남았고 하나님은 그를 높이셨습니다!"
      }
    },

    12: {
      name: "파라오의 꿈",
      challenge: "일곱 마리의 살찐 암소... 일곱 마리의 여윈 암소...",
      easy: {
        question: "몇 마리의 여윈 암소가 살찐 암소를 삼켰습니까?",
        options: ["5", "6", "7", "8"],
        hint: "완전한 숫자",
        funFact: "🐄 숫자 7은 성경에서 완전함과 충만함을 상징합니다!"
      },
      medium: {
        question: "꿈 속의 7년은 무엇을 의미했습니까?",
        options: [
          "7년의 전쟁 후 평화",
          "7년의 풍년 후 7년의 기근",
          "7년의 질병 후 건강",
          "7년의 비 후 가뭄"
        ],
        hint: "풍요와 부족의 순환",
        funFact: "🌾 요셉은 이 해석으로 이집트와 그의 가족을 구했습니다!"
      },
      hard: {
        question: "하나님의 지혜는 어떻게 위기를 변환시킵니까?",
        options: [
          "모든 위기를 피한다",
          "준비할 수 있도록 선견지명을 준다",
          "악인을 벌한다",
          "신자를 부유하게 한다"
        ],
        hint: "준비와 예측에 관한 것입니다",
        funFact: "💡 하나님의 지혜는 위기를 구원의 기회로 변환시킵니다!"
      }
    },

    13: {
      name: "형제들의 화해",
      challenge: "나는 요셉입니다. 여러분이 팔았던 형제입니다...",
      easy: {
        question: "요셉은 베냐민의 자루에 무엇을 넣었습니까?",
        options: [
          "금",
          "자신의 반지",
          "자신의 은잔",
          "편지"
        ],
        hint: "귀중한 개인 물건",
        funFact: "🏆 그 잔은 물로 미래를 '읽는' 데에도 사용되었습니다!"
      },
      medium: {
        question: "요셉은 악이 선으로 변환된 것에 대해 무슨 유명한 말을 했습니까?",
        options: [
          "나는 여러분을 용서합니다",
          "당신들은 나를 해하려 했으나 하나님은 그것을 선으로 바꾸셨습니다",
          "과거를 잊읍시다",
          "복수는 하나님의 것"
        ],
        hint: "하나님의 섭리에 대한 말",
        funFact: "✨ 이 말은 우리 삶의 모든 하나님의 섭리를 요약합니다!"
      },
      hard: {
        question: "용서는 어떻게 복수의 순환을 깨뜨립니까?",
        options: [
          "악을 잊는다",
          "가해자와 피해자 모두를 새로운 시작으로 해방시킨다",
          "먼저 벌한다",
          "거리를 유지한다"
        ],
        hint: "상호 해방에 관한 것입니다",
        funFact: "🕊️ 요셉의 용서는 보편적인 하나님의 용서를 예시합니다!"
      }
    }
  }
};

export default chapter1Translations;
